export const validateStateMixin = {
    methods: {
        validateState(ref) {
            let refObj = this.$validator.fields.find({ name: ref }) || null;
            if (!refObj) {
                return null;
            }

            let refValue = this.$validator.fields.find({ name: ref }).value || null;
            let refFlags = this.$validator.fields.find({ name: ref }).flags || null;
            let refIsRequired = this.$validator.fields.find({ name: ref }).isRequired || null;

            if (refObj && ((refIsRequired && !refValue) || refValue) && (refFlags.dirty || refFlags.validated)) {
                return !this.errors.has(ref);
            } else {
                return null;
            }
        }
    }
};